import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/express/price/rule/page',
    method: 'POST',
    data: params
  })
}

// 保存规则
export const rulesSave = (params) => {
  return request({
    url: env.ferryUrl + '/express/price/rule/saveOrUpdate',
    method: 'post',
    data: params
  })
}

// 规则详情
export const rulesDetail = (id) => {
  return request({
    url: env.ferryUrl + `/express/price/rule/info/${id}`,
    method: 'get'
  })
}

// 删除计价规则
export const rulesDelete = (id) => {
  return request({
    url: env.ferryUrl + `/express/price/rule/delete/${id}`,
    method: 'DELETE'
  })
}
